import { atom } from "jotai";
import type { LoginEntryPoint } from "#/lib/analytics";

export const loginDialogOpenAtom = atom(false);

/**
 * Entry point of the in-flight login, read by the login dialog when it emits
 * `login_started`. Every opener sets this immediately before opening the dialog
 * (see `useWallet().connect`), so attribution reflects the triggering surface.
 */
export const loginEntryPointAtom = atom<LoginEntryPoint>("unknown");
